import { ServerStyleSheet } from 'styled-components';
import 'idempotent-babel-polyfill';
import Chat from './Chat';

declare var global: any;

global.Styled = { ServerStyleSheet };
global.Chat = Chat;
